import { getNextOffset } from '@wix/da-shared-react/pkg/Stream/withOffset/selectors';
import { SELLER_DISCOUNTS_STREAM } from '../../../constants';
import { getItemsPerFetch } from '@wix/da-shared-react/pkg/Stream/base/selectors';
import {
  PapiRequestStudioDiscountsInit,
  PapiStudioDiscountsInit,
} from '@wix/da-papi-types';
import { fetchStreamContents } from '@wix/da-shared-react/pkg/Stream/helpers';
import { select } from 'redux-saga/effects';
import { getActiveSection } from '../../selectors/studio';

export function* handleFetchNextSellerDiscounts() {
  const { offset, limit } = yield select(state => ({
    offset: getNextOffset(state, SELLER_DISCOUNTS_STREAM.streamId),
    limit: getItemsPerFetch(state, SELLER_DISCOUNTS_STREAM.streamId),
  }));
  const activeSection = yield select(getActiveSection);

  yield fetchStreamContents<
    PapiRequestStudioDiscountsInit,
    PapiStudioDiscountsInit
  >({
    streamId: SELLER_DISCOUNTS_STREAM.streamId,
    params: {
      filter: activeSection,
      offset,
      limit,
    },
    url: 'studio/discounts/init',
    papiProject: 'studio',
    getStreamData: result => ({
      hasMore: Boolean(result.hasMore),
      items: result.results as any,
      nextOffset: result.nextOffset ?? undefined,
    }),
  });
}
